import React, { useCallback } from "react";
import TextoInfoFarol from "../TextoInfoFarol";
import { t, useTranslations } from "adapters/i18n";
import dayjs from "dayjs";

type ValorRebanho = {
  Lotes: {
    IdCategoriaAnimal: number | null;
    DataPesagem: string | null;
    DataPesagemVisual: string | null;
    Quantidade: number | null;
    PesoMedido: number | null;
    PesoVisual: number | null;
    PesoVisualArroba: number | null;
    PesoProjetadoArroba: number | null;
    PesoMedidoArroba: number | null;
    PesoProjetado: number | null;
  }[];
  QuantidadeLotes: null | number;
};

export const montaPesoComArroba = (
  peso: number | null,
  pesoArroba: number | null,
) => {
  const pesoEmKg = `${peso} ${t("common:measure.KG")}`;

  if (pesoArroba === null || pesoArroba === undefined) {
    return pesoEmKg;
  }

  return `${pesoEmKg} (${pesoArroba}${t("common:measure.arroba")})`;
};

export type FarolPastoRebanho = {
  AreaAberta: number | null;
  AreaEfetiva: number | null;
  Cor: string | null;
  IdPasto: number;
  Valor: ValorRebanho | null;
};

export const MontaTextoTooltipRebanho = (
  title: string,
  farolPasto: FarolPastoRebanho,
  categoriasLotes: any,
) => {
  const { t } = useTranslations();

  const textoComponente = useCallback(() => {
    let properties: { [key: string]: [string] }[] = [];

    if (farolPasto && farolPasto.Valor) {
      properties = farolPasto.Valor.Lotes.map((lote, index) => {
        const categoria = categoriasLotes.find(
          (categoriaLote: any) =>
            categoriaLote.IdCategoriaAnimal === lote.IdCategoriaAnimal,
        );
        const dataFormatadaPesagem = lote.DataPesagem
          ? dayjs(lote.DataPesagem).format("DD/MM/YYYY")
          : "N/A";
        const dataFormatadaPesagemVisual = lote.DataPesagemVisual
          ? dayjs(lote.DataPesagemVisual).format("DD/MM/YYYY")
          : "N/A";

        const innerPropertie: { [key: string]: [string] } = {};

        if (categoria) {
          const nHeads = `${lote.Quantidade} cab`;
          innerPropertie[categoria.Nome.toUpperCase()] = [""];
          innerPropertie["_" + index] = [nHeads];

          const isPesoVisual =
            dayjs(lote.DataPesagemVisual).isAfter(lote.DataPesagem) ||
            lote.PesoMedido === null ||
            lote.PesoMedido === 0;
          const isPesoMedido =
            dayjs(lote.DataPesagem).isAfter(lote.DataPesagemVisual) ||
            lote.PesoMedido != null;

          if (isPesoVisual) {
            const label = t("statusIndicator:visual-weight-day-collection", {
              date: dataFormatadaPesagemVisual,
            });
            const value = montaPesoComArroba(
              lote.PesoVisual,
              lote.PesoVisualArroba,
            );
            innerPropertie[label] = [value];
          } else if (isPesoMedido) {
            const label = t("statusIndicator:mesured-weight-day-collection", {
              date: dataFormatadaPesagem,
            });
            const value = montaPesoComArroba(
              lote.PesoMedido,
              lote.PesoMedidoArroba,
            );
            innerPropertie[label] = [value];
          }

          if (lote.PesoProjetado != null) {
            const label = t("statusIndicator:today-projected-weight");
            const value = montaPesoComArroba(
              lote.PesoProjetado,
              lote.PesoProjetadoArroba,
            );
            innerPropertie[label] = [value];
          }
        }
        return innerPropertie;
      });

      const lastPropertie: { [key: string]: [string] } = {};

      if (farolPasto.AreaEfetiva != null) {
        const label = t("statusIndicator:effective-area");
        const value = farolPasto.AreaEfetiva + "% ";
        lastPropertie[label] = [value];
      }

      if (farolPasto.AreaAberta != null) {
        const label = t("statusIndicator:opened-area");
        const value = farolPasto.AreaAberta + "ha ";
        lastPropertie[label] = [value];
      }

      properties = [...properties, lastPropertie];
    }
    return (
      <TextoInfoFarol
        title={title}
        properties={properties}
        titleAdornmentColor={""}
      />
    );
  }, [title, farolPasto]);

  return () => textoComponente();
};
